import { BinRangeResponse } from 'src/models/binRange.models'
import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectPostingCreditCardFromState = (state: RootState): boolean =>
  state.app.registerAccount.postingCreditCard
export const selectFetchingIssuerFromState = (state: RootState): boolean =>
  state.app.registerAccount.fetchingIssuer
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.registerAccount.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.registerAccount.errorDetailMap
export const selectBinRangeInfoFromState = (
  state: RootState,
): BinRangeResponse | undefined => state.app.registerAccount.binRangeInfo
export const selectIssuerIdFromState = (state: RootState): string | undefined =>
  state.app.registerAccount.binRangeInfo?.issuerId?.trim()
